module.exports = __webpack_public_path__ + "img/salesforce.31013b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/salesforce.png
// module id = nNYL
// module chunks = 39 44